const BranchType = Object.freeze({
  funnow: 0,
  funbook: 1,
  funnow_funbook: 2
})

const BranchInlineTagType = Object.freeze({
  none: 0,
  product: 1,
  branch: 2
})

const BranchInvoiceType = Object.freeze({
  Invoice: 0,
  Merchant: 1,
  Receipt: 2,
  Mutual: 3,
  Personal: 4,
  MutualReceipt: 5
})

const BranchSettingReserveMode = Object.freeze({
  ProductFirst: 0,
  HeadcountFirst: 1,
  SelltimeFirst: 2
})

// NOTE: Name must be lower case to meet data name in formData
const BranchPlatform = Object.freeze({
  funnow: 0,
  inline: 1,
  ebisol: 2,
  tableapp: 3,
  ezding: 4,
  shalom: 5,
  hexa: 6,
  usen: 7
})

const RwGType = Object.freeze({
  Beauty: 0,
  Dinning: 1
})

const RwGFeeType = Object.freeze({
  False: 0,
  SilverPlan: 1,
  GoldenPlan: 2,
  BasicPlan: 3
})

const BranchVATType = Object.freeze({
  Registered: 0,
  ZeroRate: 1,
  Exempt: 2
})

export function getBranchPlatform (v) {
  return Object.keys(BranchPlatform).find(key => BranchPlatform[key] === v)
}

export function isBranchPlatformExists (v, name) {
  return v === BranchPlatform[name] && this.formData[name]
}

export function isBranchPlatformNone (v) {
  return (v === BranchPlatform.funnow)
}

export function isBranchSpecificPlatformForCustNum (v) {
  switch (v) {
    case BranchPlatform.inline:
    case BranchPlatform.ebisol:
    case BranchPlatform.usen:
      return true
    default:
      return false
  }
}

// NOTE: Name must be lower case to meet data name in formData
const BranchPMSType = Object.freeze({
  none: 0,
  shalom: 1,
  wise: 2,
  dunqian: 3,
  bistrochat: 4
})

export function getBranchPMSType (v) {
  return Object.keys(BranchPMSType).find(key => BranchPMSType[key] === v)
}

export function isBranchPMSExists (v, name) {
  return v === BranchPMSType[name] && this.formData[name]
}

export function isBranchPMSNone (v) {
  return (v === BranchPMSType.none)
}

// NOTE: Name must be lower case to meet data name in formData
const BranchCRMType = Object.freeze({
  none: 0,
  ocard: 1
})

export function getBranchCRMType (v) {
  return Object.keys(BranchCRMType).find(key => BranchCRMType[key] === v)
}

export function isBranchCRMExists (v, name) {
  return v === BranchCRMType[name] && this.formData[name]
}

export function isBranchCRMNone (v) {
  return (v === BranchCRMType.none)
}

// NOTE: Name must be lower case to meet data name in formData
const BranchBUStatus = Object.freeze({
  none: 0,
  onboarding: 1,
  verification: 2,
  live: 3,
  active: 4,
  suspended: 5,
  inactive: 6,
  churn: 7,
  nwa: 8
})

export function getBranchBUStatus (v) {
  return Object.keys(BranchBUStatus).find(key => BranchBUStatus[key] === v)
}

export function isBranchBrandTypeStatusExists (v, name) {
  return v === BranchBUStatus[name] && this.formData[name]
}

export function isBranchBrandTypeStatusNone (v) {
  return (v === BranchBUStatus.none)
}

const BranchAOSFormStatus = Object.freeze({
  Draft: 0,
  Submitted: 1,
  Rejected: 2,
  Approved: 3,
  Syncing: 4,
  Synced: 5
})

export {
  BranchType,
  BranchInlineTagType,
  BranchInvoiceType,
  BranchSettingReserveMode,
  BranchPlatform,
  BranchPMSType,
  BranchCRMType,
  BranchVATType,
  RwGType,
  RwGFeeType,
  BranchBUStatus,
  BranchAOSFormStatus
}
